import React, { useEffect, useState } from 'react'
import {
  GET,
  GET_SOURCE_TYPES_FOR_DROPDOWNS,
  GET_DROPDOWN_OPTIONS_USING_SOURCETYPE,
} from '../../../requests'

const ServerSelect2Src = ({
  name,
  sourceCode,
  optionsSource,
  value,
  emptyOptionValue,
  emptyOptionLabel,
  onChange,
  setParamNumber,
  defaultOptions,
}) => {
  const [options, setOptions] = useState([{ value: null, key: -1, label: 'Loading' }])
  const [parameterOptions, setParametersOptions] = useState([])

  useEffect(() => {
    if (sourceCode === 'undefined') {
      sourceCode = '0'
    }
    if (value === 'undefined') {
      value = '0'
    }
    if (name == 'sourceCode') {
      GET_SOURCE_TYPES_FOR_DROPDOWNS(
        (response) => {
          if (!value) {
            onChange(name, response[0].value)
          }
          setOptions(response)
        },
        (error) => {
          console.error(error)
        }
      )
    } else if (name == 'optionsSource') {
      GET_DROPDOWN_OPTIONS_USING_SOURCETYPE(
        sourceCode,
        (response) => {
            onChange(
              name,
              response.Options.find((x) => x.value == value) ? value : response.Options[0].value
            )
            setOptions(response.Options)
            setParametersOptions(response.ParameterApiOptions)
            SetParameters(
              !response.Options.find((x) => x.value == value) ? response.Options[0].value : value,
              response.ParameterApiOptions
            )
        },
        (error) => {
          console.error(error)
        }
      )
    }
    else if(name == 'value' && !!optionsSource){
      onChange('options', [{ label: '[Select An Option]', value: 'default' }]);

      let sourceIndex = optionsSource.value ? optionsSource.value : (optionsSource ? optionsSource : 0);

      GET_DROPDOWN_OPTIONS_USING_SOURCETYPE(
        sourceCode,
        (response) => {
        GET(response.ParameterApiOptions.find((x) => x.DropDownOptionsSourceId == sourceIndex).FlumeApiCall, (response) => {
            onChange('options', [{ label: '[Select An Option]', value: 'default' }, ...response]);
          },
          (error) => {
            console.error(error)
          }
        )
      });
    }
  }, [sourceCode,optionsSource])

  useEffect(() => {
    if (name == 'value') {
      setOptions(defaultOptions)
    }
  }, [defaultOptions])

  const handleChange = (e) => {
    if (name == 'optionsSource') {
      SetParameters(e.target.value, parameterOptions)
    }
    onChange(name, e.target.value)
  }

  const SetParameters = (value, parameterOptions) => {
    let source = parameterOptions.find((x) => x.DropDownOptionsSourceId == value)

    if (source && source.ParameterApiCall) {
      GET(
        source.ParameterApiCall,
        (request) => {
          setParamNumber(request, value)
        },
        (error) => {
          console.error(error)
        }
      )
    } else {
      setParamNumber([], value)
    }
  }

  return (
    <div>
      {/* value: {value} */}
      <select onChange={handleChange} value={value}>
        {emptyOptionLabel && emptyOptionValue && (
          <option value={emptyOptionValue && null}>{emptyOptionLabel}</option>
        )}
        {!options || options.length < 0 ? (
          <option value={-1} key={'none'}>
            {' '}
            Cannot Find Options{' '}
          </option>
        ) : (
          options.map((option, i) => {
            return (
              <option value={option.value} key={i}>
                {option.label}
              </option>
            )
          })
        )}
      </select>
    </div>
  )
}

export default ServerSelect2Src
